<template>
  <form class="step step_large" @submit.prevent="submit">

    <div class="step-row separator">
      <div class="step-row__title text_large">{{ i18n.sale_choose_fund_type() }}</div>

      <div class="switcher">
        <md-button
          class="switcher__btn"
          :class="form.internal_type === 'deposit' || form.internal_type === 'equity' ? 'active' : ''"
          @click="setType('deposit')"
        >{{ i18n.sale_type_crowdinvesting() }}</md-button>
        <md-button
          class="switcher__btn"
          :class="form.internal_type === 'crowdfunding' ? 'active' : ''"
          @click="setType('crowdfunding')"
        >{{ i18n.sale_type_crowdfunding() }}</md-button>
      </div>

      <div class="step-row__description text_medium">
        {{ form.internal_type === 'crowdfunding' ? i18n.sale_type_description() : i18n.sale_type_description_investing() }}
      </div>
    </div>

    <div v-if="form.internal_type === 'deposit' || form.internal_type === 'equity'" class="step-row">
      <div class="step-row__title text_large">{{ i18n.sale_choose_fund_subtype() }}</div>

      <div class="switcher">
        <md-button
          class="switcher__btn"
          :class="form.internal_type === 'deposit' ? 'active' : ''"
          @click="setType('deposit')"
        >{{ i18n.sale_subtype_deposit() }}</md-button>
        <md-button
          class="switcher__btn"
          :class="form.internal_type === 'equity' ? 'active' : ''"
          @click="setType('equity')"
        >{{ i18n.sale_subtype_equity() }}</md-button>
      </div>

      <div class="step-row__description text_margin text_medium">
        {{ form.internal_type === 'deposit' ? i18n.sale_subtype_description() : i18n.sale_subtype_description_equity() }}
      </div>

      <div v-if="form.internal_type === 'deposit'" class="step__inputs-wrap">

        <div>
          <input-field v-model="form.annual_percentage"
                       v-validate="{
                      required: true,
                      decimal: 2,
                      max: 5
                     }"
                       class="field_medium field__number field_percent"
                       name="some-another"
                       id="sale-year-earn"
                       type="number"
                       :label="i18n.sale_year_earn()"
                       placeholder="0.00"
                       :errorMessage="errorMessage('some-another')"
          />
        </div>
        <md-field class="field_medium">
          <label for="payments_frequency">{{ i18n.sale_payout_frequency() }}</label>
          <md-select v-model="form.payments_frequency"
                     name="payments_frequency"
                     id="payments_frequency"
                     :mdClass="'select_menu'"
                     :placeholder="form.payments_frequency">
            <md-option v-for="(val, i) in salePeriods" :value="val" :key="val">{{ i18n[getTranslate(val)]() }}</md-option>
          </md-select>
        </md-field>

        <input-field v-model="form.loan_term"
                     v-validate="{
                      required: true,
                      decimal: 0
                     }"
                     class="field_medium field__number"
                     name="loan_term"
                     id="loan_term"
                     type="number"
                     :label="i18n.sale_loan_term()"
                     :placeholder="i18n.lbl_enter_quantity()"
                     :errorMessage="errorMessage('loan_term')"
        />
      </div>
      <div v-else-if="form.internal_type === 'equity'" class="step__inputs-wrap">
        <div class="step-row__title text_small">{{ i18n.sale_interest_profitability() }}</div>

        <div class="field-wrap">
            <input-field v-model="form.profitability_from"
                         v-validate="{
                          required:true,
                          amount: true
                         }"
                         class="field_short field__number field_percent"
                         name="sale-interest-from"
                         id="sale-interest-from"
                         type="number"
                         :label="i18n.sale_interest_from()"
                         :errorMessage="errorMessage('sale-interest-from')"
            />

            <input-field v-model="form.profitability_to"
                         v-validate="{
                          required:true,
                          amount: true
                         }"
                         class="field_short field__number field_percent"
                         name="sale-interest-to"
                         id="sale-interest-to"
                         type="number"
                         :label="i18n.sale_interest_to()"
                         :errorMessage="errorMessage('sale-interest-to')"
            />
        </div>

        <md-field class="step-row__field field_medium">
          <label for="payments_frequency">{{ i18n.sale_payout_frequency_divid() }}</label>
          <md-select v-model="form.payments_frequency"
                     name="payments_frequency"
                     id="payments_frequency"
                     :placeholder="form.payments_frequency">
            <md-option v-for="(val, i) in salePeriods" :value="val" :key="val">{{ i18n[getTranslate(val)]() }}</md-option>
          </md-select>
        </md-field>

        <md-field class="step-row__field field_medium">
          <label for="financial_frequency">{{ i18n.sale_equity_reporting() }}</label>
          <md-select v-model="form.financial_frequency"
                     name="financial_frequency"
                     id="financial_frequency"
                     :placeholder="form.financial_frequency">
            <md-option v-for="(val, i) in salePeriods" :value="val" :key="val">{{ i18n[getTranslate(val)]() }}</md-option>
          </md-select>
        </md-field>

      </div>
    </div>
    <div class="btn-wrap column step-row">
      <md-button type="submit" class="btn md-primary" :disabled="isPending">
        {{ i18n.sale_next_step() }}
      </md-button>
    </div>
  </form>
</template>

<script>
  import StepMixin from './step.mixin'
  import config from '@conf'
  import { ErrorHandler } from '@js/errors/error_handler'
  import { commonEvents } from '@js/events/common_events'
  import { i18n } from '@js/i18n'
  import _pick from 'lodash/pick'
  import { TheMask } from 'vue-the-mask'

  export default {
    name: 'StepFundType',
    mixins: [StepMixin],
    components: { TheMask },
    data: _ => ({
      form: {
        internal_type: config.DEFAULT_FUND_TYPE,
        payments_frequency: config.SALE_PERIOD_VARIANTS[0],
        loan_term: config.SALE_PERIOD_VARIANTS[0],
        financial_frequency: config.SALE_PERIOD_VARIANTS[0],
        min_term: '',
        term: '',
        annual_percentage: '',
        profitability_from: '',
        profitability_to: ''
      },
      salePeriods: config.SALE_PERIOD_VARIANTS,
      i18n,
      config
    }),

    async created () {
      this.form = _pick(this.sale, Object.keys(this.form))
      if (!this.form.internal_type) {
        this.form.internal_type = config.DEFAULT_FUND_TYPE
      }
    },

    computed: {
    },

    methods: {
      setType (type) {
        this.form.internal_type = type
      },
      getTranslate (val) {
        return ('sale_period_' + val.replace('-', '_'))
      },
      async submit () {
        if (!await this.isValid()) return
        this.disable()
        try {
          this.$emit(commonEvents.saleUpdateEvent, {
            form: this.form
          })
        } catch (error) {
          ErrorHandler.processUnexpected(error)
        }
        this.enable()
      }
    }
  }
</script>

<style scoped lang="scss">
  @import './step.scss';
</style>



// WEBPACK FOOTER //
// src/vue/app/saleCreation/steps/Step.FundType.vue